import VTooltip from './VTooltip.vue';

export { VTooltip };
export default VTooltip;
